import {ErrorInfo} from 'react'
import {ErrorBoundary, FallbackProps} from 'react-error-boundary'

interface GenericErrorBoundaryProps {
  children: React.ReactNode
  fallbackRender: (fallbackProps: FallbackProps) => React.ReactNode
  onReset?: () => void
  onError?: (error: Error, info: ErrorInfo) => void
}

export const GenericErrorBoundary = ({
  children,
  fallbackRender,
  onError,
  onReset
}: GenericErrorBoundaryProps) => {
  // Note: React 18 and libraries like react-error-boundary use unknown for the error parameter
  // because JS throw can throw anything (not just Error objects).
  // Adapter to match react-error-boundary's expected signature
  const handleError = onError as unknown as (error: unknown, info: ErrorInfo) => void

  return (
    <ErrorBoundary fallbackRender={fallbackRender} onReset={onReset} onError={handleError}>
      {children}
    </ErrorBoundary>
  )
}
